var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12V6C22 3.79086 20.2091 2 18 2H6C3.79086 2 2 3.79086 2 6V13C2 15.2091 3.79086 17 6 17H8",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6845 21L21.9843 18.6005C22.1177 17.5333 21.3831 16.5517 20.3217 16.3786L18 16V13.5C18 12.6716 17.3284 12 16.5 12V12C15.6715 12 15 12.6716 15 13.5V17.9998L14.4145 17.4142C14.1492 17.149 13.7895 17 13.4144 17C13.0393 17 12.6795 17.149 12.4143 17.4142V17.4142C11.9376 17.891 11.8636 18.6379 12.2375 19.1988L13.4382 21",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71616 6.48789C8.86355 6.18918 9.16775 6.00006 9.50084 6.00006C9.83393 6.00006 10.1381 6.18918 10.2855 6.48789L10.7307 7.39037C10.8581 7.64867 11.1045 7.82772 11.3895 7.86915L12.3854 8.0139C12.7149 8.06182 12.9887 8.29262 13.0916 8.60928C13.1945 8.92594 13.1088 9.27359 12.8705 9.50611L12.1496 10.2093C11.9435 10.4103 11.8495 10.6998 11.8981 10.9836L12.0683 11.9752C12.1245 12.3034 11.9896 12.6351 11.7202 12.8309C11.4508 13.0266 11.0936 13.0525 10.7988 12.8976L9.9079 12.4294C9.65305 12.2954 9.34863 12.2954 9.09378 12.4294L8.20285 12.8976C7.90805 13.0525 7.55089 13.0266 7.28149 12.8309C7.01209 12.6351 6.87716 12.3034 6.93343 11.9752L7.10354 10.9836C7.15221 10.6998 7.05819 10.4103 6.8521 10.2093L6.13119 9.50611C5.89285 9.27359 5.80714 8.92594 5.91008 8.60928C6.01302 8.29262 6.28676 8.06182 6.61627 8.0139L7.61214 7.86915C7.89717 7.82772 8.14355 7.64867 8.27097 7.39037L8.71616 6.48789Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.00d3c8671062ecd87070cd7189580963.svg";
export { ForwardRef as ReactComponent };